import {
  CommonParamsType,
  CommonSuccessResponse,
} from "constants/types/common";
import { UserResponse } from "constants/types/user";
import { useMemo } from "react";
import useSWR from "swr";
import { serialize } from "utils/validation/string";

export const getUserListKey = (params?: CommonParamsType) => {
  return `/user?${serialize({ ...params })}`;
};

export const useUsers = (params?: CommonParamsType) => {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data: CommonSuccessResponse<UserResponse[]> | undefined;
    error: any;
    isLoading: boolean;
    mutate: any;
  } = useSWR(getUserListKey(params), { refreshInterval: 0 });

  const pagination = data?.meta;
  const users = data?.data;

  const userOptions = useMemo(
    () =>
      users?.map((user) => ({
        label: `${user.fullname} (${user.code})`,
        value: user.id,
      })),
    [users],
  );

  return {
    users,
    userOptions,
    pagination,
    error,
    isLoading,
    mutate,
  };
};

export const useUserMap = (): Record<string, UserResponse> => {
  const { users } = useUsers();
  return useMemo(
    () => Object.fromEntries((users ?? []).map((u) => [u.id, u])),
    [users],
  );
};
